import React, { useEffect, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { useAccessRoleUIContext } from '../AccessRoleUIContext';
import { AccessRoleEditDialogHeader } from './AccessRoleEditDialogHeader';
import { AccessRoleEditForm } from './AccessRoleEditForm';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../_redux/access-role/accessRoleAction';
import { toast } from 'react-toastify';
import { toastOption } from '../../../../../../_metronic/_helpers';

export const AccessRoleEditDialog = ({ id, show, onHide }) => {

    // AccessRole UI Context
    const accessRoleUIContext = useAccessRoleUIContext();
    const accessRoleUIProps = useMemo(() => {
        return {
            initAccessRole: accessRoleUIContext.initAccessRole,
            queryParams: accessRoleUIContext.queryParams,
            setQueryParams: accessRoleUIContext.setQueryParams,
        };
    }, [accessRoleUIContext]);

    // AccessRole Redux state
    const dispatch = useDispatch();
    const { actionsLoading, accessRoleForEdit, error, roleMaster } = useSelector(
        (state) => ({
            actionsLoading: state.accessRoles.actionsLoading,
            accessRoleForEdit: state.accessRoles.accessRoleForEdit,
            roleMaster: state.accessRoles.roleMaster,
            error: state.accessRoles.error
        }),
        shallowEqual,
    );

    if (error) {
        toast.error(error, toastOption)
    }
    useEffect(() => {
        // server call for getting AccessRole by id
        dispatch(actions.fetchAccessRole(id));
        dispatch(actions.fetchRoleMaster());
    }, [id, dispatch]);

    const saveAccessRole = (accessRole) => {
        if (!id) {
            dispatch(actions.createAccessRole(accessRole)).then((response) => {
                if (response)
                    toast.success(response.message, toastOption);
                dispatch(actions.fetchAccessRoles(accessRoleUIProps.queryParams)).then(() => onHide());
            });

        } else {
            dispatch(actions.updateAccessRole(accessRole)).then((response) => {
                if (response)

                    toast.success(response.message, toastOption);
                dispatch(actions.fetchAccessRoles(accessRoleUIProps.queryParams)).then(() => onHide());
            });
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="modal-sizes-title-lg"
            size="xl"
            backdrop="static"
            fullscreen={true}
            animation={true}
        >
            <AccessRoleEditDialogHeader id={id} />
            <AccessRoleEditForm
                saveAccessRole={saveAccessRole}
                actionsLoading={actionsLoading}
                accessRole={accessRoleForEdit || accessRoleUIProps.initAccessRole}
                onHide={onHide}
                roleMaster={roleMaster}
                id={id}
            />
        </Modal>
    );
};
